/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { Input } from 'react-native-elements-light';
import {
  formControl,
  formControlError,
  formLabel,
  formLabelError,
  formControlContainer,
  formInputText,
  formInputTextError,
  formControlFilled,
  formControlFilledOtp,
  formControlFilledNewOtp,
  formControlFilledNew,
  formControlNew,
} from '~assets/styles/formStyles';
import { isNative } from '~global/screens';

const InputDefault = (props) => {
  const { maxLength } = props;
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isFilled, setIsFilled] = useState('');
  const [focused, setFocused] = useState(false);

  const inputRef = useRef(null);
  const changeNativeName = useCallback(() => {
    // inputRef?.current?.setNativeProps({
    //   name: Math.random(),
    //   role: 'presentation',
    // });
  }, []);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!isNative) {
        changeNativeName();
      }
      if (props?.inputRef) {
        props.inputRef(inputRef.current);
      }
    }
    return () => {
      mounted = false;
    };
  }, [inputRef]);

  useEffect(() => {
    if (props.value && !isFilled) {
      setIsErrorHandler(props.value);
    }
  }, [props.value, isFilled]);

  const setIsErrorHandler = (e) => {
    const value = e.nativeEvent && e.nativeEvent.text ? e.nativeEvent.text : e;
    setIsFilled(Boolean(value));

    if (global.$validate.single(value, props.validate)) {
      setIsError(true);
      setErrorMessage(global.$validate.single(value, props.validate)[0]);
      if (props.getErrorStyles) {
        props.getErrorStyles({
          error: true,
          labelStyle: formLabelError,
          inputContainerStyle: formControlError,
          errorStyle: formInputTextError,
        });
      }
      return;
    }

    if (props.getErrorStyles) {
      props.getErrorStyles({
        error: false,
        labelStyle: {},
        inputContainerStyle: {},
        errorStyle: formInputTextError,
      });
    }

    setIsError(false);
    setErrorMessage('');
  };

  const formLabelErrorControl = isError || props.hasError ? formLabelError : {};
  const formControlErrorControl =
    isError || props.hasError
      ? props.isTextArea
        ? {
            ...formControlError,
            ...styles.textAreaContainer,
            ...(props.formControlErrorControl
              ? props.formControlErrorControl
              : {}),
          }
        : {
            ...formControlError,
            ...(props.formControlErrorControl
              ? props.formControlErrorControl
              : {}),
          }
      : {};
  const renderErrorMessageControl = isError || props.hasError;
  const errorMessageControl = errorMessage || props.hasError;
  const formControlFilledControl = isFilled
    ? props.inputContainerStyleFilled
      ? props.inputContainerStyleFilled
      : props.isInputsOtp
      ? props?.newInputs
        ? formControlFilledNewOtp
        : formControlFilledOtp
      : props?.newInputs
      ? formControlFilledNew
      : formControlFilled
    : {};

  return (
    <Input
      onBlur={setIsErrorHandler}
      onFocus={() => {
        if ((isError || errorMessage) && global.isNative) {
          setIsError(false);
          setErrorMessage('');
        }
        if (props?.onFocus) {
          props.onFocus();
        }
        props.isInputsOtp && setFocused(true);
      }}
      {...props}
      labelStyle={{
        ...formLabel,
        ...formLabelErrorControl,
        ...props.labelStyle,
      }}
      inputContainerStyle={{
        ...(!props?.newInputs && formControl),
        ...(props?.newInputs && formControlNew),
        ...formControlFilledControl,
        ...formControlErrorControl,
        ...props.inputContainerStyle,

        ...(focused
          ? props?.newInputs
            ? formControlFilledNewOtp
            : formControlFilledOtp
          : {}),
        ...(!isNative ? { outlineWidth: 0 } : {}),
        ...(props.isTextArea
          ? {
              height: 100,
            }
          : {}),
      }}
      {...(!isNative && {
        inputStyle: [
          { outlineWidth: 0, outlineStyle: 'none' },
          props.inputStyle ? props.inputStyle : {},
        ],
      })}
      containerStyle={{ ...formControlContainer, ...props.containerStyle }}
      style={{ ...formInputText, ...props.style }}
      errorStyle={{ ...formInputTextError, ...props.errorStyle }}
      errorMessage={errorMessageControl ? errorMessageControl : ''}
      renderErrorMessage={
        renderErrorMessageControl ? renderErrorMessageControl : false
      }
      autoCapitalize="none"
      autoCorrect={false}
      autoComplete="new-password"
      maxLength={maxLength ? maxLength : 50}
      ref={(ref) => (inputRef.current = ref)}
    />
  );
};

const styles = StyleSheet.create({
  textAreaContainer: {
    height: 80,
    alignItems: 'flex-start',
  },
});

export default React.memo(InputDefault);
